/**
 * A short row label for an off-platform ask.
 *
 * An ask carries no `title` of its own — just the instruction on its action
 * config — so the setup row would otherwise render the ENTIRE `instruction` —
 * a multi-paragraph brief that dwarfed every neighbouring row. Take the first
 * sentence and cap it, so the row reads like "Instagram Post" and "Create
 * Email" do; the full brief still lives in the panel, unclamped.
 */
export const ownerActionRowTitle = (
	instruction: string | undefined,
	fallback: string,
): string => {
	const text = (instruction ?? '').trim().replace(/\s+/g, ' ');
	if (!text) return fallback;
	// First sentence, but never a fragment so short it says nothing (an
	// instruction can open with "Go." or an abbreviation).
	const firstSentence = /^(.*?[.!?])(?:\s|$)/.exec(text)?.[1];
	const lead =
		firstSentence && firstSentence.length >= 20 ? firstSentence : text;
	// Drop a trailing subordinate clause ("… at veracityhealth.co/quiz BEFORE
	// activating this campaign") — the row is a label and the qualifier lives in
	// the panel. Keeps it near the weight of "Instagram Post"/"Create Email".
	const trimmed = lead.replace(
		/,?\s+\b(before|after|so that|so|once|when|while|then|and then)\b.*$/i,
		'',
	);
	const clean = (trimmed.length >= 16 ? trimmed : lead).replace(/[.\s]+$/, '');
	return clean.length > 48 ? `${clean.slice(0, 47).trimEnd()}…` : clean;
};
